import { render } from "./AuthorizationRegistriesToolHomeView.vue?vue&type=template&id=6edb58cf"
import script from "./AuthorizationRegistriesToolHomeView.vue?vue&type=script&lang=js"
export * from "./AuthorizationRegistriesToolHomeView.vue?vue&type=script&lang=js"

import "./AuthorizationRegistriesToolHomeView.vue?vue&type=style&index=0&id=6edb58cf&lang=css"

import exportComponent from "/Users/pierre_josselin/Documents/GitHub/ouranos-ws-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__